/**
 * Created by Christof Sander on 04.05.2017.
 */
const utils = require('frontend-controller/lib/utils');

module.exports = {
	hooks: {
		attach: function($element, options){
			var images = utils.media.image.detectRendered(this.model.image, storage, this.model._image, false, true, function(event){
				var renderedUrl = ((((images || {}).imageList || [])[0] || {}).rendered || {}).url;
				if(event.type === 'load' && renderedUrl){
					$element.find('.image').removeClass('loading').css('background-image', 'url(' + renderedUrl + ')');
				}
			});
		}
	}
};